import React, {useCallback, useState} from 'react';

import {useBulkActionDialog} from 'src/components/bulk-tool/useBulkActionDialog';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {BulkUpdateCRMIDSModal} from 'src/modules/bulk-update';
import {CreateAccountButton} from 'src/modules/create-account';
import {CreateConferenceButton} from 'src/modules/create-conference';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';


import {GeneralSearch} from './components/general-search';

import {mainHeader, mainHeaderCaption, mainHeaderSearchBlock} from './main-header.module.styl';

export const BULK_UPDATE_CRM_ID_TOOL_CAPTION = 'Bulk Update User CRM IDs';

export const MainHeader = () => {
    const [updateUserCRMIDShown, setUpdateUserCRMIDShown] = useState(false);

    const {bulkOpen, bulkSubmit} = useEventTracking();

    const {hasAccess} = useAdminAccessRight();

    const canUpdateCRM = hasAccess(ACCESS_RIGHTS.BULK_UPDATE_USER_CRM);
    const canCreateAccount = hasAccess(ACCESS_RIGHTS.ACCOUNT_SCREEN_CREATE);
    const canCreateConference = hasAccess(ACCESS_RIGHTS.CONFERENCE_SETUP);

    const openBulkBulkUpdateCrmIdTool = useCallback(() => {
        bulkOpen({toolName: BULK_UPDATE_CRM_ID_TOOL_CAPTION});
        setUpdateUserCRMIDShown(true);
    }, [bulkOpen]);

    const closeBulkBulkUpdateCrmIdTool = useCallback(() => {
        bulkSubmit({toolName: BULK_UPDATE_CRM_ID_TOOL_CAPTION, submit: false});
        setUpdateUserCRMIDShown(false);
    }, [bulkSubmit]);

    const {onClose: closeCrmDialog, onPendingChange} = useBulkActionDialog(closeBulkBulkUpdateCrmIdTool);

    const submitBulkBulkUpdateCrmIdTool = useCallback(() => {
        bulkSubmit({toolName: BULK_UPDATE_CRM_ID_TOOL_CAPTION, submit: true});
        setUpdateUserCRMIDShown(false);
    }, [bulkSubmit]);

    return (
        <div className={mainHeader}>
            <div className={mainHeaderSearchBlock}>
                <h1 className={mainHeaderCaption}>Account Administration</h1>
                <GeneralSearch/>
            </div>
            <Group>
                {[canUpdateCRM].some(Boolean) && (
                    <DropdownMenu anchor={({positionRef, getAnchorProps, anchorRef}) => (
                        <Button
                            variant="Type.SECONDARY"
                            endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                            {...getAnchorProps()}
                            ref={anchorRef}>
                            Bulk Upload
                        </Button>
                    )}>
                        {canUpdateCRM ? (
                            <DropdownMenuItem
                                caption="Bulk Update User CRM IDs"
                                onClick={openBulkBulkUpdateCrmIdTool}
                            />
                        ) : null}
                    </DropdownMenu>
                )}
                {canCreateConference ? <CreateConferenceButton/> : null}
                {canCreateAccount ? <CreateAccountButton/> : null}
            </Group>
            {updateUserCRMIDShown ? (
                <Dialog
                    shown={updateUserCRMIDShown}
                    setShown={value => {
                        if (!value) {
                            closeCrmDialog();
                        }
                    }}
                    wrapperProps={{style: {width: 800}}}>
                    <BulkUpdateCRMIDSModal
                        onClose={closeCrmDialog}
                        onPendingChange={onPendingChange}
                        onSubmit={submitBulkBulkUpdateCrmIdTool}
                    />
                </Dialog>
            ) : null}
        </div>
    );
};
